import Head from 'next/head';
import type { FC } from 'react';
import { useEffect } from 'react';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { APPLICATION_LINK, APPLICATION_TITLE, LINKS } from '@/Module/Core/Constant';
import { replaceHalfSpace } from '@/Module/Core/Helper';
import { useAppDispatch } from '@/Module/Store/Hook';
import { SubscriptionPageVideo, SubscriptionQuestion } from '@/Module/Subscription/Component';
import SubscriptionPageCore from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageNew/SubscriptionPageCore';
const SubscriptionPageContainer: FC = () => {
  const dispatch = useAppDispatch();

  /*  const VideoDetail = useMemo(() => {
    switch (activeCategoryId) {
      case 1:
        return {
          titleOne: 'این برنامه: ',
          titleTwo: 'می‌خواهی کنکور قبول شی؟ چطوری؟ \n این ویدئو رو ببین...',
          mobileVideoUrl: '256489',
          videoUrl: '256480',
        };
      case 2:
        return {
          titleOne: 'تو آزمون تیزهوشان قبول شو چطوری؟',
          titleTwo: 'این فیلم رو ببین تا بفهمی...',
          mobileVideoUrl: '136600',
          videoUrl: '134478',
        };
      case 3:
        return {
          titleOne: ' این برنامه:',
          titleTwo: ' کنکور با آی‌نو چجوری میشه؟',
          mobileVideoUrl: '136601',
          videoUrl: '134477',
        };
      default:
        return {
          titleOne: ' ',
          titleTwo: '',
          mobileVideoUrl: '437449',
          videoUrl: '437449',
        };
    }
  }, [activeCategoryId]);
  */

  const Video = {
    titleOne: ' ',
    titleTwo: '',
    mobileVideoUrl: '437449',
    videoUrl: '437449'
  };
  const pageTitle = 'خرید اشتراک آی نو و خرید اشتراک کنکور و امتحان نهایی';
  const pageDescription = 'اشتراک آی نو – اشتراک سامانه آموزش مجازی آی نو چیست؟ دسترسی به ویدیوهای آموزشی دروس، نکته و تست، آزمون و هرچیزی که برای آمادگی کنکور یا تیزهوشان نیاز دارید';
  useEffect(() => {
    dispatch(authSetIsTransitioningAction(false));
  }, [dispatch]);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="SubscriptionPageContainer.tsx">
        <title>{replaceHalfSpace(pageTitle)}</title>
        <meta name="description" content={replaceHalfSpace(pageDescription)} data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <link rel="canonical" href={`https://ino.school/${LINKS.SUBSCRIPTION.MAIN}`} />
        <meta property="og:locale" content="fa_IR" data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta property="og:type" content="website" data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta property="og:title" content={pageTitle} data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta property="og:description" content={replaceHalfSpace(pageDescription)} data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta property="og:url" content={`${APPLICATION_LINK}${LINKS.SUBSCRIPTION.MAIN}`} data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta property="og:site_name" content={replaceHalfSpace(APPLICATION_TITLE)} data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta name="twitter:card" content="summary_large_image" data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta name="twitter:title" content={pageTitle} data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
        <meta name="twitter:description" content={replaceHalfSpace(pageDescription)} data-sentry-element="meta" data-sentry-source-file="SubscriptionPageContainer.tsx" />
      </Head>
      <SubscriptionPageCore data-sentry-element="SubscriptionPageCore" data-sentry-source-file="SubscriptionPageContainer.tsx" />
      <SubscriptionPageVideo url={Video.videoUrl} titleOne={Video.titleOne} titleTwo={Video.titleTwo} urlMobile={Video.mobileVideoUrl} data-sentry-element="SubscriptionPageVideo" data-sentry-source-file="SubscriptionPageContainer.tsx" />
      <SubscriptionQuestion data-sentry-element="SubscriptionQuestion" data-sentry-source-file="SubscriptionPageContainer.tsx" />
    </>;
};
export default SubscriptionPageContainer;